import React from "react";

import "./LoaderImgStyle.css"

const LoaderImg = () => {
  return (
    <div className="loadingio-spinner-double-ring-fwxl3phwb08">
      <div className="ldio-eyk1pubtabv">
        <div></div>
        <div></div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default LoaderImg;
